module.exports = __webpack_public_path__ + "static/media/Categoria5Alimentos.7b7866af.jpg";